<p-dialog class="flex-wrap" (onHide)="closeDialog()"
          [(visible)]="visible" [closable]="true" [modal]="true"
          [style]="{width: '90vw', height: '90vh','min-width': '400px', 'min-height': '300px','max-width': '1200px', 'max-height': '650px'}"
          [draggable]="false" [resizable]="false" closeIcon="pi pi-times loading-icon-size">
    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <i class="pi pi-tag text-blue-500 text-2xl"></i>
            <span class="white-space-nowrap">
                        REQUISITOS - {{ this.tramiteStats.nombreTramite! }}
                </span>
        </div>
    </ng-template>
    @if (this.tramiteStats) {
        <div *ngIf="datosCargados; else loading">
            <p-messages severity="error" *ngIf="this.tramiteStats.idProyecto==null">
                <ng-template pTemplate>
                    <div class="ml-2  text-xl">Estimado usuario, necesita registrar su proyecto para visualizar esta
                        información
                    </div>
                </ng-template>
            </p-messages>
            <div>
                <p-messages severity="warn">
                    <ng-template pTemplate>
                        <div class="flex justify-content-between align-items-center w-full">
                            <p class="m-0 text-2xl">Esta ventana es informativa.</p>
                            <!-- Agregar funcionalidad al boton -->
                            <p-button
                                label="Ir a pagos"
                                (onClick)="completarPagos()"
                                icon="pi pi-arrow-right"
                                styleClass="p-button-rounded border-none px-3 py-2 ml-auto"
                                [style]="{ 'background-color': '#3B82F6' }">
                            </p-button>
                        </div>
                    </ng-template>
                </p-messages>
            </div>
            @for (items of this._requisitosInfo().requisitos; track $index; ) {
                <b>
                    <div class="text-900 font-semibold mb-3">{{ items.descripcion }} ({{ items.requisitos.length }})
                    </div>
                </b>
                <!--Vista de solo lectura-->
                <div class="row">
                    <div>
                        <div class="field col-12">
                            <p-listbox
                                [options]="items.requisitos"
                                [(ngModel)]="selectedRequisito"
                                optionLabel="nombre"
                                [listStyle]="{'max-height': '220px'}">
                                <ng-template let-requisitos pTemplate="item">
                                    <div class="flex align-items-center gap-2 ml-1"
                                         [pTooltip]="requisitos.idArchivoEstadoRq==1?'Fecha carga de archivo:  '+requisitos.fechaModificacion:'Falta completar requisito'">
                                        <div>{{ requisitos.nombre }}</div>
                                        <div>
                                            <i [ngClass]="requisitos.idArchivoEstadoRq == 1 ? 'pi pi-verified' : 'pi pi-info-circle'"
                                               [ngStyle]="{'color': requisitos.idArchivoEstadoRq == 1 ? 'green' : null}">
                                            </i>
                                        </div>
                                    </div>
                                </ng-template>
                            </p-listbox>
                        </div>
                    </div>
                </div>
            }
        </div>

    }
</p-dialog>

